// extracted by mini-css-extract-plugin
export var borderRadius = "_f9-4";
export var large = "_f9-3";
export var logoContainer = "_f9-0";
export var nameLogo = "_f9-2";
export var small = "_f9-1";